import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Greg has been my business coach for the past two years. He helped our leadership navigate a complicated corporate merger, and was very instrumental in working with all stakeholders to chart a path forward. Greg has very high EQ, a thoughtful and intentional communication style, and incredible character.',
    name: 'Jonathan L.',
    occupation: 'VP of Commercial Real Estate, Colliers',
    photo: null,
    initials: 'JL'
  }, {
    quote: "Through the coaching sessions, I got more clarity about my purpose, confidence and self-awareness. One of the things I like the most about Greg is how good he is at asking the right questions at the right time. Greg's coaching helped me through an important time of decision regarding my career.",
    name: 'Karin Rotman',
    occupation: 'Occupational Doctor, Belgium',
    photo: 'https://cdn.magicpatterns.com/uploads/tuczWezcZFPYCj1pjAHeP1/Karin_Rotman.jpg',
    initials: 'KR'
  }, {
    quote: 'I used the learnings in a multinational company where I was holding a senior position, handling 7 countries. The company promoted me and increased my salary twice in the same year. Also, I created stronger relationships with my team. He helped me like no one else ever did.',
    name: 'Adrian Puiu',
    occupation: 'Leadership Trainer, Coach & Speaker',
    photo: 'https://cdn.magicpatterns.com/uploads/wVWpgsqPQ2jz4kruKSxKKw/Adrian_Puiu.jpg',
    initials: 'AP'
  }, {
    quote: 'Through his thoughtful guidance, I gained much-needed clarity and my anxiety was dramatically reduced, allowing me to move forward with greater confidence. Greg brings a high level of seniority and experience, yet his calm and grounded demeanor immediately puts you at ease.',
    name: 'Stefano Ferrara',
    occupation: 'Sr Director and Team Leader',
    photo: 'https://cdn.magicpatterns.com/uploads/i3jsUHQYBVhVQbk27fjCGw/Stefano_Ferrara.jpg',
    initials: 'SF'
  }, {
    quote: 'As head of HR, I have referred Greg to many of our executives and third parties without hesitation. He is a highly professional, knowledgeable, and experienced leadership coach. He is known for demonstrating pragmatic approaches that help his clients achieve rapid, meaningful success.',
    name: 'Bonnie Cinquemani',
    occupation: 'Director of Talent Management, Aerojet Rocketdyne',
    photo: 'https://cdn.magicpatterns.com/uploads/m8m6pS5v2SPcELXTHFxPcX/Bonnie_Cinquemani.jpg',
    initials: 'BC'
  }, {
    quote: "The Coaching School was a turning point in my professional life. It refined my voice, deepened my sense of purpose, and equipped me to lead and serve with greater clarity and conviction. The profound impact didn't stop with me; it has since flowed into the lives of many others.",
    name: 'Pastor Jesse Birth',
    occupation: 'MBA, Harvard Alumni',
    photo: null,
    initials: 'JB'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-253">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 md:mb-24" data-id="element-255">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-256">
            <div className="w-12 h-[1.5px] bg-gold" data-id="element-257" />
            <span className="font-heading font-bold text-[17px] text-gold uppercase tracking-[0.1em]" data-id="element-258">
              Testimonials
            </span>
            <div className="w-12 h-[1.5px] bg-gold" data-id="element-259" />
          </div>
          <h2 className="text-[28px] md:text-[36px] tracking-[-0.02em]" data-id="element-260">
            What leaders say about working with me
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-261">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-warm-gray border-[0.5px] border-warm-border border-l-2 border-l-gold rounded-xl p-8 md:p-10 flex flex-col h-full" data-id="element-262">
              <div className="text-gold text-[64px] font-subtitle leading-[0.8] mb-2 select-none" data-id="element-263">
                &ldquo;
              </div>
              <p className="font-subtitle italic text-[16px] md:text-[17px] leading-[1.75] text-navy mb-8 flex-grow" data-id="element-264">
                {testimonial.quote}
              </p>
              <div className="pt-6 border-t border-warm-border flex items-center gap-4" data-id="element-265">
                {testimonial.photo ? <img src={testimonial.photo} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover object-top border-2 border-gold/30 flex-shrink-0" data-id="element-266" /> : <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center flex-shrink-0 border-2 border-gold/30" data-id="element-267">
                    <span className="font-heading font-bold text-[14px] text-white" data-id="element-268">
                      {testimonial.initials}
                    </span>
                  </div>}
                <div data-id="element-269">
                  <p className="font-heading font-bold text-[15px] text-navy mb-1" data-id="element-270">
                    {testimonial.name}
                  </p>
                  <p className="text-[13px] text-charcoal/80" data-id="element-271">
                    {testimonial.occupation}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}